function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
import * as actions from '../actions/orderHistoryActions';
import { distinct } from '../../helpers/arrayHelper';
var initialState = {
  openOrders: [],
  inactiveOrders: [],
  accountTrades: [],
  tradeReports: [],
  activeRequests: 0
};
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case actions.RECEIVE_TRADE_HISTORY:
      return Object.assign({}, state, {
        accountTrades: distinct(payload, function (trade) {
          return trade.TradeId;
        })
      });
    case actions.REQUEST_OPEN_ORDERS:
    case actions.REQUEST_ACCOUNT_TRADES:
    case actions.REQUEST_INACTIVE_ORDERS:
    case actions.REQUEST_TRADE_REPORTS:
      return Object.assign({}, state, {
        activeRequests: ++state.activeRequests
      });
    case actions.RECEIVE_ACCOUNT_TRADES:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests,
        accountTrades: distinct(payload, function (trade) {
          return trade.TradeId;
        })
      });
    case actions.ADD_ACCOUNT_TRADE:
      return Object.assign({}, state, {
        accountTrades: [payload].concat(_toConsumableArray(state.accountTrades))
      });
    case actions.RECEIVE_OPEN_ORDERS:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests,
        openOrders: payload
      });
    case actions.ADD_OPEN_ORDER:
      return Object.assign({}, state, {
        openOrders: distinct([payload].concat(_toConsumableArray(state.openOrders)), function (order) {
          return order.OrderId;
        })
      });
    case actions.RECEIVE_INACTIVE_ORDERS:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests,
        inactiveOrders: payload
      });
    case actions.ADD_INACTIVE_ORDER:
      return Object.assign({}, state, {
        inactiveOrders: [payload].concat(_toConsumableArray(state.inactiveOrders)),
        openOrders: filterOpenOrders(state.openOrders, payload)
      });
    case actions.RECEIVE_TRADE_REPORTS:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests,
        tradeReports: payload
      });
    case actions.RECEIVE_ACCOUNT_TRADES_FOR_ORDER_ID:
      return Object.assign({}, state, {
        accountTrades: distinct([].concat(_toConsumableArray(payload), _toConsumableArray(state.accountTrades)), function (trade) {
          return trade.TradeId;
        })
      });
    case actions.REMOVE_ACTIVE_REQUEST:
      return Object.assign({}, state, {
        activeRequests: --state.activeRequests
      });
    default:
      return state;
  }
}
var filterOpenOrders = function filterOpenOrders(openOrders, order) {
  return openOrders ? openOrders.filter(function (_ref2) {
    var OrderId = _ref2.OrderId;
    return OrderId !== order.OrderId;
  }) : [];
};